import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Tier from './Tier'

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    maxWidth: 300,
    margin: '0px',
    marginTop: '18px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Tiers = ({
  onChange,
  disabled,
  error,
  title,
  tiers,
  tier_variations,
  tier_brands,
  ...props
}) => {

const handleChange = event => {
  onChange(event, 'tiers')
}

const tiers_to_show = [{'id': 0, name: 'Delanteras'},{'id': 1, name: 'Traseras'},{'id': 3, name: 'Auxilio'},{'id': 4, name: 'Todas'}]
tiers.tiers_to_show = parseInt(tiers.tiers_to_show)
return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
        <FormControl className="" style={{minwidth: 120, fontSize: '0.75rem'}} name={"tiers_to_show"} >
          <Select native name={".tiers_to_show"}
              inputProps={{
                name:"tiers_to_show",
                className:"tiers_to_show"
              }}
              style={{minwidth: 120, fontSize: '0.75rem', marginLeft: '8px'}}
              disabled={disabled}
              value={tiers.tiers_to_show}
              onChange={handleChange}
              input={<Input id="grouped-native-select" name={'tiers_to_show'}/>}>
              <option value="" />
              {tiers_to_show.map((tiers_to_sho) =>
                  <option id={tiers_to_sho.id} value={tiers_to_sho.id}>{tiers_to_sho.name}</option>
              )}
          </Select>
        </FormControl>
      </Typography>
      <div className="col-11 mr-auto">
        <div className="row">
          <div className="col-4 ml-auto">
            <Tier title={'Delantera izquierda'} tier_variations={tier_variations} tier_brands={tier_brands} tier={tiers.tiers[0]} onChange={handleChange} display={(tiers.tiers_to_show === 0 || tiers.tiers_to_show === 4)}/>
            <Tier title={'Trasera izquierda'} tier_variations={tier_variations} tier_brands={tier_brands} tier={tiers.tiers[2]} onChange={handleChange} display={(tiers.tiers_to_show === 1 || tiers.tiers_to_show === 4)}/>
          </div>
          <div className="col-2 p-0 mx-auto">
            <img src="../../../../car.svg" />
          </div>
          <div className="col-4">
            <Tier title={'Delantera derecha'} tier_variations={tier_variations} tier_brands={tier_brands} tier={tiers.tiers[1]} onChange={handleChange}  display={(tiers.tiers_to_show === 0 || tiers.tiers_to_show === 4)}/>
            <Tier title={'Trasera derecha'} tier_variations={tier_variations} tier_brands={tier_brands} tier={tiers.tiers[3]} onChange={handleChange}  display={(tiers.tiers_to_show === 1 || tiers.tiers_to_show === 4)} />
          </div>
        </div>
      </div>
      <div className="col-4 mx-auto text-left">
        <Tier title={'Auxilio'} tier_variations={tier_variations} tier_brands={tier_brands} tier={tiers.tiers[4]} onChange={handleChange}  display={(tiers.tiers_to_show === 3 || tiers.tiers_to_show === 4)}/>
      </div>
    </React.Fragment>
    )
}

export default Tiers;

